import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Panel from '../../../../components/angle/Panel';
import Spinner from '../../../../components/Spinner/index';
import EditClassForm from '../../components/ClassForm';
import { formInputValidation } from '../../../../services/helper/form-helper';
import {
    fetchCountries,
    fetchStates
} from '../../../../services/redux/commonData/actions';
import {
    updatePendingClass,
    updateEditPendingClassPayload
} from '../../../../services/redux/employee/security/actions';
import { editClass } from '../../../../services/redux/employee/classes/actions';

class EditPendingClass extends Component {
    constructor(props) {
        super(props);
        this.classFormRef = React.createRef();
    }
    componentDidMount() {
        let { fetchCountries, fetchStates } = this.props;
        fetchCountries();
        fetchStates();
    }

    onSaveApproveClick = () => {
        let { security, history, editClass } = this.props;
        let payload = security.editPendingClass;
        payload = { ...payload, approvedStatus: 2 };
        if (formInputValidation(this.classFormRef.current)) {
            editClass(payload).then(response => {
                if (response.status === 200) {
                    history.push('/pending-securities');
                }
            });
        }
    };

    onDenyClick = () => {
        let { security, history, editClass } = this.props;
        let payload = security.editPendingClass;
        payload = { ...payload, approvedStatus: 3 };
        editClass(payload).then(response => {
            if (response.status === 200) {
                history.push('/pending-securities');
            }
        });
    };

    onCancelClick = () => {
        let { history } = this.props;
        history.push('/pending-securities');
    };

    render() {
        let {
            security,
            portfolio,
            commonData,
            updateEditPendingClassPayload,
            roleName
        } = this.props;
        let isAdmin = roleName === 'Administrator';
        let saveApproveButton = isAdmin && (
            <button
                type="button"
                className="btn btn-default btn-bordered"
                onClick={this.onSaveApproveClick}
            >
                Save & Approve
            </button>
        );

        let denyButton = isAdmin && (
            <button
                type="button"
                className="btn btn-default btn-bordered"
                onClick={this.onDenyClick}
            >
                Deny
            </button>
        );

        let cancelButton = (
            <button
                type="button"
                className="btn btn-default btn-bordered"
                onClick={this.onCancelClick}
            >
                Back
            </button>
        );

        const buttonList = [saveApproveButton, denyButton, cancelButton];

        return (
            <div>
                <Panel
                    showHeader
                    header="Edit Pending Class"
                    showFooter
                    footerComponents={buttonList}
                >
                    <div className="col-lg-6 col-md-8 col-sm-12">
                        <EditClassForm
                            parentPortfolios={portfolio.portfolios}
                            classData={security.editPendingClass}
                            countryList={commonData.countries}
                            stateList={commonData.states}
                            updateClassData={updateEditPendingClassPayload}
                            formRef={this.classFormRef}
                            isEditable={isAdmin}
                        />
                    </div>
                </Panel>
                {(security.fetching || portfolio.fetching) && <Spinner />}
            </div>
        );
    }
}

const mapStateToProps = state => ({
    security: state.employee.security,
    portfolio: state.employee.portfolio,
    commonData: state.commonData,
    roleName: state.authentication.user
        ? state.authentication.user.roleName
        : ''
});

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            fetchCountries,
            fetchStates,
            updatePendingClass,
            updateEditPendingClassPayload,
            editClass
        },
        dispatch
    );

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(EditPendingClass));



// WEBPACK FOOTER //
// ./src/screens/EmployeePanel/screens/PendingSecurities/EditPendingClass.js